<div class="o-grid o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" [ngClass]="{'o-grid__cell--right': vm.user?.id===vm.group.user}">
		<div class="o-grid" [ngClass]="{'o-grid--reverse-h': vm.user?.id!==vm.group.user}">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<div class="chat-message-inner-container" style="display: block;"
						(mouseenter)="vm.onMouseEnter(vm.message)" (mouseleave)="vm.onMouseLeave(vm.message)" #messageBusinessCardContainer>
					<button class="dots-btn-horizontal"
							*ngIf="!vm.message.deleted && vm.user?.id===vm.message.user.id && (vm.isDesktop ? vm.message.showDots : true)"
							(click)="vm.toggleActions(vm.message, $event, messageBusinessCardContainer)">
						...
					</button>
				<div class="c-message__bc c-message__bc--fw" *ngIf="!vm.message.deleted">
					<div onerror="this.style.visibility='hidden'" class="c-image c-image--bg c-image--round c-image--md" *ngIf="vm.isValidPictureUrl(vm.metadata.user?.profilePicture?.thumbnailUrl)" [ngStyle]="{ 'background-image': 'url(' + vm.metadata.user?.profilePicture?.thumbnailUrl + ')' }"></div>
					<div class="c-image c-image--bg c-image--round c-image--md" *ngIf="!vm.metadata.user?.profilePicture?.thumbnailUrl"></div>
					<div style="margin-left:15px;flex:1;text-align:left;">
						<div id="chatItemBusinessCardPersonName" class="c-text c-text--bold">{{vm.metadata.user.firstname}} {{vm.metadata.user.lastname}}</div>
						<div id="chatItemBusinessCardServiceTitle" class="c-text" *ngIf="vm.metadata.parentServiceTitle">{{vm.metadata.parentServiceTitle}}</div>				
						<div id="chatItemBusinessCardOccupation" class="c-text" *ngIf="vm.occupation">{{vm.occupation}}</div>
						<div style="text-align:right;margin-top: 10px;">
							<a id="chatItemBusinessCardViewButton" style="margin:5px;" target="_blank" [routerLink]="['/specialist', vm.metadata.id]">{{ 'Services.Button.View' | translate }}</a>
							<a id="chatItemBusinessCardBookButton" *ngIf="!vm.user?.businessUser" style="margin:5px;cursor:pointer;" target="_blank" (click)="vm.book()">{{ 'Services.Button.Book' | translate }}</a>
						</div>
					</div>
				</div>
					<div class="c-message__bc c-message__bc--fw" *ngIf="vm.message.deleted" style="width: 100px;">
						<p id="chatSimpleTextMessageItem"
						   class="chatSimpleTextMessageItem c-text c-text--wrap"
						   [ngClass]="{'c-message-deleted': vm.message.deleted}"
						   [innerHtml]="vm.message.content">
						</p>
					</div>
					<div class="chat-actions-menu"
						 *ngIf="vm.message.showActions"
						 (click)="$event.stopPropagation()">
						<button (click)="vm.deleteMessage(vm.message)">
							 {{ 'Modal.Title.Delete' | translate }}
						</button>
					</div>
				</div>
		</div>
	</div>
	<div class="o-grid__cell--w-100" style="padding-top:3px;padding-bottom:5px;" [ngClass]="{'c-message--right': vm.user?.id===vm.message.user.id}" >
        <span class="c-text c-message--footer">{{vm.message.created | date:'HH:mm'}}</span>
        <span *ngIf="vm.user?.id===vm.message.user.id" class="c-text c-text--gray c-text--bold c-message--footer" [ngClass]="{'c-message--seen' : vm.message.id <= vm.lastSeen}">&check;</span>
    </div>
</div>